import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { select, Store } from '@ngrx/store';

import {
  AccountState,
  addStoredPermission,
  getStoredPermissions,
  PermissionService,
  ResourceMode,
  Rule,
} from 'src/app/core';
@Directive({
  selector: '[appAccessCtrl]',
})
export class AccessCtrlDirective {
  private _rule: Rule;
  storedPermissions: { [key: string]: boolean } = {};

  @Input() set appAccessCtrl(res: string) {
    this.processRule(res);
  }

  get rule() {
    return this._rule;
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private permissionService: PermissionService,
    private viewContainer: ViewContainerRef,
    private store: Store<AccountState>
  ) {
    this.getStoredPermissions();
  }

  ngOnInit() {
    this._grantAccess(this.rule);
  }

  processRule(res: string) {
    if (typeof res === 'undefined') {
      throw new Error('Resource string cannot be undefined');
    } else if (Array.isArray(res)) {
      throw new Error('Resource should not be an array.');
    }

    const rule: Rule = { res, mode: ResourceMode.VIEW };

    this._rule = rule;
  }

  private _grantAccess(rule: Rule) {
    const checkedPermission = this.checkStoredPermissions();

    if (typeof checkedPermission !== 'undefined') {
      if (checkedPermission) {
        this.action3();
      } else {
        this.action4();
      }
    } else if (
      typeof rule !== 'undefined' &&
      this.permissionService.grantAccess(rule)
    ) {
      this.action1(rule);
    } else {
      this.action2(rule);
    }
  }

  action1(rule: Rule) {
    this.showComponent();
    this.addStoredPermission(rule, true);
    return true;
  }

  action2(rule: Rule) {
    this.clearComponent();
    this.addStoredPermission(rule, false);
    return false;
  }

  action3() {
    this.showComponent();
    return true;
  }

  action4() {
    this.clearComponent();
    return false;
  }

  showComponent() {
    this.viewContainer.createEmbeddedView(this.templateRef);
  }

  clearComponent() {
    this.viewContainer.clear();
  }

  checkStoredPermissions(): boolean | undefined {
    const checkedPermission = this.storedPermissions
      ? this.storedPermissions[this.rule.res]
      : undefined;
    if (typeof checkedPermission !== 'undefined') {
      return checkedPermission;
    }
  }

  addStoredPermission(rule: Rule, access: boolean) {
    if (typeof rule !== 'undefined') {
      this.store.dispatch(addStoredPermission({ [rule.res]: access }));
    }
  }

  /**
   * Get user permissions
   */
  getStoredPermissions() {
    this.store
      .pipe(select(getStoredPermissions))
      .subscribe((storedPermissions: { [key: string]: boolean }) => {
        this.storedPermissions = storedPermissions;
      });
  }
}
